import { appPalette } from './App.palette';

const { white, dark_grey_2, light_grey_2, black, mid_grey, honda_mid_grey } =
  appPalette.colors;
const appTheme = process.env.REACT_APP_THEME;

const embedChatButtonProperties = {
  fontFamily: 'AvenirLTPro-Heavy, Arial, sans-serif',
  borderRadius: 0,
  '& .label': {
    fontSize: '0.875rem',
    fontWeight: 'unset',
    textTransform: 'uppercase',
  },
  '&:focus': {
    textDecoration: 'none !important',
  },
};

export const appClasses = {
  // defaults
  label: {
    color: dark_grey_2,
  },
  '#root': {
    width: '100%',
    ...(appTheme === 'honda' && {
      backgroundColor: honda_mid_grey,
    }),
  },
  '.page-container': {
    width: '100%',
    margin: '0 auto',
    maxWidth: '87.5rem',
    ...(appTheme === 'honda' && {
      backgroundColor: white,
      display: 'flex',
      flexDirection: 'column',
    }),
  },
  '.acr-nowrap': {
    display: 'inline',
    fontWeight: 'inherit',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
  },
  '.st-icon-button-focus': {
    '&:hover': {
      cursor: 'pointer',
    },
    '&:focus': {
      outline: `0.125rem solid ${black}`,
      outlineOffset: '0.125rem',
    },
  },
  '.st-styled-scroll': {
    '&::-webkit-scrollbar': {
      width: '0.375rem',
      height: '0.375rem',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: light_grey_2,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: mid_grey,
    },
  },
  //Odometer global classes
  '.odometer-container': {
    '&.cost': {
      '& .odometer-inside': {
        '&:before': {
          content: '"$"',
          height: '100%',
        },
      },
    },
    '&.percent': {
      '& .odometer-inside': {
        '&:after': {
          content: '"%"',
          height: '100%',
        },
      },
    },
  },
  '.odometer.odometer-auto-theme, .odometer.odometer-theme-default': {
    display: 'inline-block',
    //verticalAlign: 'middle' was removed from this class
    position: 'relative',
  },
  '.odometer.odometer-auto-theme .odometer-digit, .odometer.odometer-theme-default .odometer-digit':
    {
      display: 'inline-block',
      //verticalAlign: 'middle' was removed from this class
      position: 'relative',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-digit-spacer, .odometer.odometer-theme-default .odometer-digit .odometer-digit-spacer':
    {
      display: 'inline-block',
      //verticalAlign: 'middle' was removed from this class
      visibility: 'hidden',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-digit-inner, .odometer.odometer-theme-default .odometer-digit .odometer-digit-inner':
    {
      textAlign: 'left',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon, .odometer.odometer-theme-default .odometer-digit .odometer-ribbon':
    {
      display: 'block',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-ribbon-inner, .odometer.odometer-theme-default .odometer-digit .odometer-ribbon-inner':
    {
      display: 'block',
      webkitBackfaceVisibility: 'hidden',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-value, .odometer.odometer-theme-default .odometer-digit .odometer-value':
    {
      display: 'block',
      transform: 'translateZ(0)',
    },
  '.odometer.odometer-auto-theme .odometer-digit .odometer-value.odometer-last-value, .odometer.odometer-theme-default .odometer-digit .odometer-value.odometer-last-value':
    {
      position: 'absolute',
    },
  '.odometer.odometer-auto-theme.odometer-animating-up .odometer-ribbon-inner, .odometer.odometer-theme-default.odometer-animating-up .odometer-ribbon-inner':
    {
      transition: 'transform 2s',
    },
  '.odometer.odometer-auto-theme.odometer-animating-up.odometer-animating .odometer-ribbon-inner, .odometer.odometer-theme-default.odometer-animating-up.odometer-animating .odometer-ribbon-inner':
    {
      transform: 'translateY(-100%)',
    },
  '.odometer.odometer-auto-theme.odometer-animating-down .odometer-ribbon-inner, .odometer.odometer-theme-default.odometer-animating-down .odometer-ribbon-inner':
    {
      transform: 'translateY(-100%)',
    },
  '.odometer.odometer-auto-theme.odometer-animating-down.odometer-animating .odometer-ribbon-inner, .odometer.odometer-theme-default.odometer-animating-down.odometer-animating .odometer-ribbon-inner':
    {
      transition: 'transform 2s',
      transform: 'translateY(0)',
    },

  '.odometer.odometer-auto-theme .odometer-value, .odometer.odometer-theme-default .odometer-value':
    {
      textAlign: 'center',
    },
  //NEW CONCIERGE LIVECHAT CLASSES
  '.embeddedServiceSidebar, .embeddedServiceHelpButton': {
    zIndex: 98 + ' !important',
  },
  '.updated-concierge-styles .embeddedServiceHelpButton .embeddedServiceIcon': {
    marginRight: '0.5rem !important',
    marginLeft: '0',
  },
  '.embeddedServiceHelpButton .embeddedServiceIcon': {
    marginRight: '3px',
    marginLeft: '3px',
  },
  '.updated-concierge-styles .embeddedServiceHelpButton .helpButton': {
    bottom: '4.625rem !important',
    fontFamily: 'AvenirLTPro-Roman, Arial, sans-serif',
  },
  '.embeddedServiceHelpButton .helpButton': {
    bottom: '1.25rem !important',
    fontFamily: 'AvenirLTPro-Roman, Arial, sans-serif',
  },
  '.loading-embed-chat .embeddedServiceHelpButton .helpButton .uiButton': {
    visibility: 'hidden',
  },
  '.updated-concierge-styles .embeddedServiceHelpButton .helpButton .uiButton':
    {
      backgroundColor: '#222',
      fontSize: '0.875rem',
      border: `0.0625rem solid`,
      borderColor: `${mid_grey} !important`,
      borderRadius: '1.5625rem !important',
      minWidth: '7.5rem',
      width: '7.5rem',
      padding: '0.8125rem !important',
      height: '2.875rem !important',
      '&:before': {
        display: 'none',
      },
    },
  '.embeddedServiceHelpButton .helpButton .uiButton': {
    backgroundColor: '#222',
    fontSize: '0.875rem',
    border: `0.0625rem solid`,
    borderColor: `${mid_grey} !important`,
    borderRadius: '1.5625rem !important',
    minWidth: '11.5rem',
    width: '11.5rem',
    height: '2.875rem !important',
    '&:before': {
      display: 'none',
    },
  },
  '.helpButtonEnabled:focus .helpButtonLabel': {
    textDecoration: 'none !important',
  },
  '.embeddedServiceSidebarButton': {
    background: '#222',
  },
  '.embeddedServiceSidebarForm .fieldList .embeddedServiceSidebarFormField .uiInput .uiLabel':
    {
      fontFamily: 'AvenirLTPro-Roman, Arial, sans-serif',
      fontSize: '0.875rem',
      color: '#000',
      padding: '0.0625rem',
      fontWeight: '400',
      marginLeft: '0.25rem',
      marginRight: '0',
    },
  '.embeddedServiceSidebarForm .uiButton': {
    ...embedChatButtonProperties,
  },
  '.embeddedServiceSidebarDialogState .dialogButtonContainer .uiButton': {
    ...embedChatButtonProperties,
  },
  '.embeddedServiceSidebarState .endChatContainer .uiButton': {
    ...embedChatButtonProperties,
  },
  '.waitingStateButtonContainer .uiButton': {
    ...embedChatButtonProperties,
  },
  '.messageArea .wrapper, .embeddedServiceSidebarState .wrapper': {
    maxWidth: 'unset !important',
    minHeight: '0 !important',
  },
  '.embeddedServiceSidebar .sidebarHeader': {
    '& .minimizeButton, .closeButton': {
      '& svg': {
        fill: 'white !important',
      },
    },
  },
  '.updated-concierge-styles .embeddedServiceSidebar .helpButton, .updated-concierge-styles .embeddedServiceSidebar .minimizedContainer':
    {
      bottom: '4.625rem !important',
      backgroundColor: '#222',
      border: `0.0625rem solid`,
      borderColor: `${mid_grey} !important`,
      borderRadius: '1.5625rem !important',
      minWidth: '7.5rem',
      width: '7.5rem',
      height: '2.875rem !important',
      padding: '0.8125rem !important',
      '& .content': {
        padding: 0,
      },
      '& .messageContent': {
        margin: 0,
        justifyContent: 'center',
        flexDirection: 'row !important',
        '& .embeddedServiceIcon': {
          marginRight: '0.5rem',
          marginLeft: '0.1875rem',
        },
        '& .minimizedImage': {
          margin: '0 0.625rem 0 0.1875rem',
          '& .uiImage': {
            width: 'auto',
            height: 'auto',
          },
          '& img': {
            width: '1.25rem',
            height: '1.4375rem',
          },
        },
        '& .minimizedText': {
          margin: '0 auto',
          '& .message': {
            fontFamily: 'AvenirLTPro-Roman, Arial, sans-serif',
            fontSize: '0.875rem',
          },
        },
      },
      '&:before': {
        display: 'none',
      },
      '&:focus': {
        textDecoration: 'none !important',
      },
    },
  '.embeddedServiceSidebar .helpButton, .embeddedServiceSidebar .minimizedContainer':
    {
      bottom: '1.25rem !important',
      backgroundColor: '#222',
      border: `0.0625rem solid`,
      borderColor: `${mid_grey} !important`,
      borderRadius: '1.5625rem !important',
      minWidth: '11.5rem',
      width: '11.5rem',
      height: '2.875rem !important',
      padding: '0.75rem !important',
      '& .content': {
        padding: 0,
      },
      '& .messageContent': {
        margin: 0,
        justifyContent: 'center',
        flexDirection: 'row !important',
        '& .embeddedServiceIcon': {
          marginRight: '0.625rem',
          marginLeft: '0.1875rem',
        },
        '& .minimizedImage': {
          margin: '0 0.625rem 0 0.1875rem',
          '& .uiImage': {
            width: 'auto',
            height: 'auto',
          },
          '& img': {
            width: '1.25rem',
            height: '1.4375rem',
          },
        },
        '& .minimizedText': {
          margin: '0 auto',
          '& .message': {
            fontFamily: 'AvenirLTPro-Roman, Arial, sans-serif',
            fontSize: '0.875rem',
          },
        },
      },
      '&:before': {
        display: 'none',
      },
      '&:focus': {
        textDecoration: 'none !important',
      },
    },
  '.embeddedServiceSidebar .dockableContainer': {
    borderRadius: '0.5rem !important',

    '@media (max-width: 550px)': {
      bottom: '0.75rem !important',
      height: 'calc(100% - 4.625rem) !important',
      left: 'auto !important',
      margin: '0 !important',
      maxHeight: 'none !important',
      position: 'fixed !important',
      right: '0.75rem !important',
      width: 'calc(100% - 1.5rem) !important',
    },

    bottom: '1.25rem !important',
  },
  '.sidebarHeader .minimizeButton, .sidebarHeader .closeButton': {
    padding: '0 0.375rem',
  },
  '.embeddedMessagingConversationButtonWrapper .embeddedMessagingConversationButton':
    {
      margin: '0px !important',
      bottom: '70px !important',
      right: '16px !important',
      display: 'flex !important',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'black !important',
      filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.20)) !important',
    },
  '.embedded-messaging > .embeddedMessagingFrame[class~="isMinimized"]': {
    bottom: '67px !important',
    right: '13px !important',
  },
  '.embedded-messaging > .embeddedMessagingFrame[class~="isMaximized"]': {
    margin: '0px !important',
    bottom: '10px !important',
    right: '16px !important',
    borderRadius: '.5rem !important',
    '@media (orientation: landscape) and (hover: none) and (pointer: coarse)': {
      height: '100vh !important',
      bottom: '15px !important',
      maxHeight: 'calc(100vh - 4.5em) !important',
      width: '100vw !important',
      maxWidth: 'calc(100vw - 2em) !important',
    },
    '@media (min-width: 550px)': {
      bottom: '140px !important',
      right: '16px !important',
      height: '30.5rem !important',
      width: '20rem !important',
      '@media (orientation: landscape) and (hover: none) and (pointer: coarse)':
        {
          height: '100vh !important',
          bottom: '15px !important',
          maxHeight: 'calc(100vh - 4.5em) !important',
          width: '100vw !important',
          maxWidth: 'calc(100vw - 2em) !important',
        },
    },
    '@media (min-width: 1024px)': {
      bottom: '140px !important',
      height: '30.5rem !important',
      width: '20rem !important',
      maxWidth: '20rem !important',
    },
  },
  '.embedded-messaging > #embeddedMessagingModalOverlay.isMaximized': {
    display: 'block',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    backgroundColor: 'rgba(51, 51, 51, 0.48)',
  },
};
